export default __webpack_public_path__ + "static/media/eerie_estates.a0f9e248.svg";